export default __webpack_public_path__ + "static/O0151-7aeadd770aa23d0b6780882c9708654a.png";